import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Featurelist from "./FeatureProductlist/Featurelist";

export default function Features({ data }) {
	// Number of items initially visible

	useEffect(() => {
		AOS.init({
			duration: 500, // Duration of the animation in milliseconds
			easing: "ease-in-out", // Easing function
			once: true, // Whether animation should happen only once - while scrolling down
		});
	}, []);

	return (
		<div className="overflow-x-hidden ">
			<div className="text-center  mb-10 overflow-hidden" data-aos="fade-left">
				<h1 className="md:text-5xl text-4xl font-semibold font-lora px-4">
					Featured Gowns
				</h1>
			</div>
			<ul
				data-aos="fade-right"
				data-aos-duration="300"
				className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 mt-20 mb-16 px-4 lg:ps-16 lg:pe-16 md:ps-10 md:pe-10 overflow-x-hidden ">
				{data.slice(0, 8).map((item) => (
					<Featurelist key={item.id} data={item} />
				))}
			</ul>
		</div>
	);
}
